module.exports = __webpack_public_path__ + "static/media/girl (3).59c20c87.png";